import React from "react";
import { isVideo } from "./galleryUtils";
import { delete_gallery } from "../../data/ApiEndpoints";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";

const GalleryView = ({
  onCloseModal,
  modValues,
  userInfoData,
  reloadGalleryData,
}) => {
  const dispatch = useDispatch();

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonPostPutApi({
              token: userInfoData?.token,
              endpoint: delete_gallery,
              method: "PUT",
              payload: { uid: filter?.uid },
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            reloadGalleryData();
            onCloseModal();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <div className="flex-k js-between-k items-center-k">
        <h3>Gallery View</h3>
        <button
          type="button"
          className="btn btn-danger btn-back"
          style={{ background: "#DC3545", border: "none" }}
          onClick={onCloseModal}
        >
          Close
        </button>{" "}
      </div>

      <br />

      <div>
        <div className="mod-width-100p grid__four">
          {modValues?.rowData?.map((row, index) => (
            <div
              className=""
              style={{
                background: "#f1f1f1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {isVideo(row?.image) ? (
                <video
                  src={row?.image}
                  style={{
                    objectFit: "contain",
                    width: "100%",
                  }}
                  controls
                />
              ) : (
                <img
                  key={index}
                  src={row?.image}
                  alt=""
                  style={{
                    objectFit: "contain",
                    width: "100%",
                  }}
                />
              )}
              <div>
                <button
                  className="deleteGalleryButton"
                  onClick={() => {
                    const uidFilter = {
                      uid: row?.uid || "",
                    };
                    handleDelete(uidFilter);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash"
                    viewBox="0 0 16 16"
                    strokeWidth="2"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                  </svg>
                  <span
                    className=""
                    style={{
                      marginLeft: "5px",
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    Delete
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryView;
